import React, { useId } from 'react';
import { COLOR_NAMES, GRADING_STYLES, GRADING_PERCENTAGE_RANGES } from '../utils/grading';
import './GradingColorReference.css';

export default function GradingColorReference({ introduction, showPercentages = false }: any) {
  const titleId = useId();

  return (
    <section className="grading-color-reference" aria-labelledby={titleId}>
      <h2 id={titleId} className="grading-color-reference-title">Understanding the Grading Colors</h2>
      <p className="grading-color-reference-intro">{introduction}</p>
      <div className="grading-color-reference-scroll" role="region" aria-label="Grading color key" tabIndex={0}>
        <ul className="grading-color-reference-list">
          {['gray', 'red', 'yellow', 'lightgreen', 'green'].map((color) => {
            const status = GRADING_STYLES[color];
            return (
              <li key={color} className={`grading-color-reference-card grading-color-reference-card-${color}`}>
                <h3 className="grading-color-reference-status">{status.label}</h3>
                <div className="grading-color-reference-copy">
                  <span className="grading-color-reference-color" style={{ background: status.bg, color: status.text }}>
                    {color === 'gray' ? 'Gray' : COLOR_NAMES[color]}
                  </span>
                  <p>{status.description}</p>
                </div>
                {showPercentages && GRADING_PERCENTAGE_RANGES[color] && (
                  <p className="grading-color-reference-range">{GRADING_PERCENTAGE_RANGES[color]}</p>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
